import { c as _c } from "react/compiler-runtime";
import { FlexColumn, SkeletonCircle, TextBodySkeleton } from "@opensea/ui-kit";
import { AccountSwitcherItem, AccountSwitcherItemAvatar, AccountSwitcherItemContent, AccountSwitcherItemDescription, AccountSwitcherItemTitle } from "./AccountSwitcherItem";
export function AccountSwitcherAccountItemsSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AccountSwitcherItemAvatar><SkeletonCircle /></AccountSwitcherItemAvatar>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AccountSwitcherItemTitle><TextBodySkeleton className="w-20" size="sm" /></AccountSwitcherItemTitle>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AccountSwitcherItem>{t0}<AccountSwitcherItemContent><FlexColumn className="items-start">{t1}<AccountSwitcherItemDescription><TextBodySkeleton className="w-16" size="xs" /></AccountSwitcherItemDescription></FlexColumn></AccountSwitcherItemContent></AccountSwitcherItem>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}